// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"TJ-z","carouselContainer":"UJ-z"};